import React, { useState } from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import pick from 'lodash/pick';
import values from 'lodash/values';
import includes from 'lodash/includes';
import { FormattedMessage } from 'react-intl';
import get from 'lodash/get';
import Divider from 'material-ui/Divider';

import moment from 'moment';
import dateFormat from 'utils/dateTools';

import {
  Checkbox,
  FontIcon,
  RaisedButton,
} from 'material-ui';

import styles from 'styles/TransportationGrant';
import KTitle from '../../components/KJRN/KTitle';
import KListItem from '../../components/KJRN/KListItem';
import { STATE_PROPS, ICONS } from './constants';

const BackCard = ({
  embed, grant, loading, handleClick, onSubmit,
}) => {
  const [transportations, setTransportations] = useState({
    [STATE_PROPS.PublicTransportation]: false,
    [STATE_PROPS.Cycling]: false,
    [STATE_PROPS.Walking]: false,
    [STATE_PROPS.TransportationCard]: false,
  });

  const handleCheck = stateProp => (_, value) => setTransportations({ ...transportations, [stateProp]: value });

  const handleSubmit = () => {
    const { HrTransportationGrantID } = grant;
    handleClick(false)();
    onSubmit({
      HrTransportationGrantID,
      ...pick(transportations, values(STATE_PROPS)),
    });
  };

  const periodStart = moment().startOf('month').add(1, 'month');
  const periodEnd = moment(periodStart).add(grant.Months - 1, 'month').endOf('month');
  const selected = includes(pick(transportations, values(STATE_PROPS)), true);

  return (
    <div>
      <div style={embed ? styles.embedCard : styles.card}>
        <KTitle style={{ marginBottom: 12 }} title={grant.HrTransportationGrantName} />
        <Divider style={styles.divider} />
        {map(STATE_PROPS, prop => (
          get(grant, prop)
            ? (
              <React.Fragment key={`${grant.HrTransportationGrantID}${prop}`}>
                {prop === STATE_PROPS.TransportationCard ? <Divider style={styles.divider} /> : null}
                <div style={styles.checkboxRow}>
                  <FontIcon style={styles.icon} className="material-icons">{get(ICONS, prop)}</FontIcon>
                  <Checkbox
                    data-cy={grant.HrTransportationGrantName === 'Bus card 6 months' ? 'Bus card' : prop}
                    checked={transportations[prop]}
                    onCheck={handleCheck(prop)}
                    label={get(grant, prop)}
                  />
                </div>
              </React.Fragment>
            ) : null
          ))}
        <div style={styles.details}>
          <KListItem disabled>
            <div style={styles.detailItem}>
              <FormattedMessage id="transportationGrant.AmountPerMonth" />
              <span style={styles.detailItemValue}>{grant.AmountPerMonth}</span>
            </div>
          </KListItem>
          <KListItem disabled>
            <div style={styles.detailItem}>
              <FormattedMessage id="transportationGrant.Months" />
              <span style={styles.detailItemValue}>{grant.Months}</span>
            </div>
          </KListItem>
          <KListItem disabled>
            <div style={styles.detailItem}>
              <FormattedMessage id="transportationGrant.period" />
              <span style={styles.detailItemValue}>{`${dateFormat(periodStart)} - ${dateFormat(periodEnd)}`}</span>
            </div>
          </KListItem>
        </div>
        <div style={styles.button}>
          <RaisedButton
            style={{ marginRight: 12 }}
            disabled={loading}
            onClick={handleClick(false)}
            icon={<FontIcon className="material-icons">arrow_back</FontIcon>}
          />
          <RaisedButton
            primary
            data-cy={`send-${grant.HrTransportationGrantName}`}
            disabled={loading || !selected}
            onClick={handleSubmit}
            label={<FormattedMessage id="transportationGrant.register.finish" />}
          />
        </div>
      </div>
    </div>
  );
};

BackCard.propTypes = {
  loading: PropTypes.bool,
  handleClick: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  embed: PropTypes.bool,
  grant: PropTypes.shape({
    HrTransportationGrantID: PropTypes.number.isRequired,
    HrTransportationGrantName: PropTypes.string.isRequired,
    PublicTransportation: PropTypes.string,
    Cycling: PropTypes.string,
    Walking: PropTypes.string,
    TransportationCard: PropTypes.string,
    Months: PropTypes.number,
    AmountPerMonth: PropTypes.string,
    Previous: PropTypes.arrayOf(PropTypes.shape({
      Begda: PropTypes.string,
      Endda: PropTypes.string,
    })),
  }).isRequired,
};

BackCard.defaultProps = {
  loading: false,
  embed: false,
};

export default BackCard;



// WEBPACK FOOTER //
// ./src/sites/transportationGrants/BackCard.js